import '@angular/common/locales/global/en-IN';
import 'moment/min/locales';

import { TitleCasePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { getAnalytics, provideAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { KeycloakAngularModule, KeycloakBearerInterceptor, KeycloakService } from '@inoventoryapps/keycloak-angular';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import Lara from '@primeng/themes/lara';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { NgxUiLoaderConfig, NgxUiLoaderHttpModule, NgxUiLoaderModule } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { ToastModule } from 'primeng/toast';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CustomSideNavComponent } from './custom-side-nav/custom-side-nav.component';
import { apiErrorInterceptor } from './interceptor/api-error.interceptor';
import { authInterceptor } from './interceptor/auth.interceptor';
import { encryptionInterceptor } from './interceptor/encryption.interceptor';
import { initializeKeycloak } from './keycloak/keycloak-init.factory';
import { ConfirmationDialogComponent } from './mobile/pages/custom-hiring-center/confirmation-dialog/confirmation-dialog.component';
import { NavStripComponent } from './nav-strip/nav-strip.component';
import { KeyService } from './services/key.service';
import { UserSessionService } from './services/user-session.service';
import { ToolbarComponent } from './toolbar/toolbar.component';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
    bgsSize: 0,
    fgsSize: 0,
    hasProgressBar: false,
    logoUrl: 'https://cdn.lokos.in/lokos-in/assets/LokOS-Circle-Animation.gif',
    overlayColor: 'transparent'
};

@NgModule({
    declarations: [AppComponent],
    imports: [
        ConfirmationDialogComponent,
        CustomSideNavComponent,
        NavStripComponent,
        ToolbarComponent,

        AppRoutingModule,
        BrowserModule,
        ToastModule,
        KeycloakAngularModule,
        MatSidenavModule,
        NgxUiLoaderHttpModule.forRoot({ showForeground: true }),
        NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
        TranslateModule.forRoot({
            loader: provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
            fallbackLang: 'en'
        })
    ],
    providers: [
        { provide: LOCALE_ID, useValue: 'en-in' },
        { provide: DEFAULT_CURRENCY_CODE, useValue: 'INR' },
        MessageService,
        TitleCasePipe,
        {
            // Single initializer: Angular runs APP_INITIALIZERs in parallel, but the user session service needs both done first
            provide: APP_INITIALIZER,
            multi: true,
            deps: [KeycloakService, KeyService, UserSessionService],
            useFactory:
                (keycloak: KeycloakService, keyService: KeyService, userSession: UserSessionService) => async () => {
                    await Promise.all([initializeKeycloak(keycloak)(), keyService.initDB()]);
                    await userSession.init().catch((error) => console.error('User session init failed:', error));
                }
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: KeycloakBearerInterceptor,
            multi: true
        },
        provideAnimationsAsync(),
        provideHttpClient(
            withInterceptorsFromDi(),
            withInterceptors([encryptionInterceptor, authInterceptor, apiErrorInterceptor])
        ),
        provideMomentDateAdapter({
            parse: {
                dateInput: 'DD-MM-YYYY'
            },
            display: {
                dateInput: 'DD-MM-YYYY',
                monthYearLabel: 'MMM YYYY',
                dateA11yLabel: 'LL',
                monthYearA11yLabel: 'MMMM YYYY'
            }
        }),
        providePrimeNG({ theme: { preset: Lara, options: { darkModeSelector: '.dark-theme' } } }),
        provideCharts(withDefaultRegisterables()),
        provideFirebaseApp(() =>
            initializeApp({
                projectId: 'gramudyamita',
                appId: '1:1017666784717:web:891c51185dfa3a2813c884',
                storageBucket: 'gramudyamita.firebasestorage.app',
                apiKey: 'AIzaSyDGhl7n6j_IRGphUGLFT2bDV55yQcVJ83E',
                authDomain: 'gramudyamita.firebaseapp.com',
                messagingSenderId: '1017666784717',
                measurementId: 'G-T2F598CDBG'
                // projectNumber: '1017666784717',
                // version: '2'
            })
        ),
        provideAnalytics(() => getAnalytics()),
        ScreenTrackingService,
        UserTrackingService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
